import type { Theme } from "@material-ui/core";
import { makeStyles } from "@material-ui/core";
import { alpha } from "@material-ui/core/styles";

export const useTableStyles = makeStyles((theme: Theme) => ({
    flexRoot: {
        display: "block",
        "& .MuiTableHead-root": {
            display: "block",
        },
        "& .MuiTableBody-root": {
            display: "block",
        },
        "& .MuiTableRow-root": {
            display: "flex",
        },
        "& .MuiTableCell-body": {
            // Flex defaults needed for IE11 since react creates IE11-broken flex shortand in useFixedFlexLayout
            display: "flex",
            flex: "1 0 auto",
            flexDirection: "column",
            justifyContent: "center",
            "&.MuiTableCell-alignCenter": {
                alignItems: "center",
            },
        },
        "& .MuiTableCell-head": {
            display: "flex",
            flex: "1 0 auto",
            flexDirection: "row",
            alignItems: "flex-end",
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",

            "&.MuiTableCell-alignCenter": {
                justifyContent: "center",
            },
        },
        "& .caption": {
            display: "block",
            padding: theme.spacing(1, 2),
            fontStyle: "italic",
            // Try to mimic style from caption element
            color: theme.palette.text.secondary,
            fontSize: "1.4rem",
            fontWeight: 400,
            lineHeight: 1.43,
            letterSpacing: "0.01071em",
        },
    },
    primarySkeletonCell: {
        display: "block !important",
        width: "100%",
    },
    primarySkeletonCellRow: {
        maxWidth: 700,
        width: "70%",
        ".MuiTableRow-root:nth-child(3n+0) &": {
            maxWidth: 600,
            width: "50%",
        },
    },
    secondarySkeletonCellRow: {
        backgroundColor: alpha(theme.palette.text.primary, 0.07),
        maxWidth: 400,
        ".MuiTableRow-root:nth-child(3n+0) &": {
            maxWidth: 300,
            width: "80%",
        },
    },
    skeletonRow: {
        display: "flex",
        flex: "1 0 auto",
        height: 80,
    },
    skeletonDotsOverlay: {
        position: "absolute",
        bottom: "1em",
    },
    skeletonDots: {
        position: "relative",
        top: "1em",
        "& > span": {
            display: "inline-block",
            margin: "0 2px",
        },
    },
    actionMenuSkeleton: {
        "& span": {
            margin: "2px 0",
        },
    },
    defaultTableRow: {
        minHeight: 80,
    },
    tableExpandRowCollapse: {
        display: "block",
        width: "100%",
    },
    tableExpandedAnimation: {
        "&-enter": {
            transform: "scale(0)",
        },
        "&-enter-active": {
            overflow: "hidden",
            transform: "none",
            margin: "8px -4px",
        },
        "&-exit-active": {
            margin: 0,
        },
    },
    tableExpandedPaper: {
        margin: 0,
        position: "relative",
        transition: theme.transitions.create(["margin", "box-shadow", "border-radius"]),
        "&-enter, &-enter-active, &-enter-done": {
            margin: "-2px -6px 10px",
            zIndex: 1,
        },
    },

    tableCellSorted: {
        backgroundColor: "rgba(0, 0, 0, 0.025)",
    },

    tableLoadingIndicatorRowContainer: {
        position: "relative",
        width: "100%",
    },
    tableLoadingIndicatorRowContainerLoading: {
        position: "absolute",
        width: "100%",
        zIndex: 12,
        top: "-4px",
    },
}));
